import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";
// Only import layout components eagerly as they're used on all pages
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

// Lazy load route components
const Index = () => import(/* webpackChunkName: "index" */ "./views/Index.vue");
const Profile = () => import(/* webpackChunkName: "profile" */ "./views/Profile.vue");
const Podcast = () => import(/* webpackChunkName: "podcast" */ "./views/Podcast.vue");
const Seances = () => import(/* webpackChunkName: "seances" */ "./views/Seances.vue");
const Sophrologie = () => import(/* webpackChunkName: "sophrologie" */ "./views/Sophrologie.vue");
const Eft = () => import(/* webpackChunkName: "eft" */ "./views/Eft.vue");
const Boutique = () => import(/* webpackChunkName: "boutique" */ "./views/Shop.vue");

Vue.use(Router);
Vue.use(Meta, {
  tagIDKeyName: 'vmid', // A property that identifies the tag
  refreshOnceOnNavigation: true,
  inject: false // This prevents duplicating meta tags
});

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      components: { default: Index, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/profil",
      name: "profile",
      components: { default: Profile, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/services",
      name: "services",
      components: { default: Seances, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/sophrologie",
      name: "sophrologie",
      components: {
        default: Sophrologie,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/boutique",
      name: "boutique",
      components: {
        default: Boutique,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/pratique-eft",
      name: "eft",
      components: {
        default: Eft,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/podcast-rencontre-avec-soi",
      name: "podcast",
      components: {
        default: Podcast,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" },
      },
    },
  ],
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});
